import Menu from "./components/Menu";
import { Link } from "react-router-dom";
import "../css/Guias.css";
import { useEffect, useState } from "react";
import { ValidarSesion } from "../shared/Validaciones";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { NMTipoGuiaRemision, NMMotivoTraslado, NMTipoDocumento, NMTipoComprobante, MostrarFecha, NMMotivoTrasladoLista } from '../shared/Denominaciones';
import Paginador from "./components/Paginador";
import Confirmacion from "./components/Confirmación";

export default function Guias(){
    // ==================================================================================================
    //#region HOOKS STATE
    // ==================================================================================================

    // ESTADOS DE FILTRO
    const[filtroSerie, setFiltroSerie] = useState("");
    const[filtroCorrelativo, setFiltroCorrelativo] = useState("");
    const[filtroProveedor, setFiltroProveedor] = useState("");
    const[filtroCliente, setFiltroCliente] = useState("");
    const[filtroFechaInicio, setFiltroFechaInicio] = useState("");
    const[filtroFechaFin, setFiltroFechaFin] = useState("");
    const[filtroTipoGuia, setFiltroTipoGuia] = useState("");

    // ESTADOS DE SELECT
    const[selectTipoGuia, setSelectTipoGuia] = useState("");

    // ESTADOS DE CONTENIDO
    const[listaGuias, setListaGuias] = useState(<></>);
    const[modalAgregar, setModalAgregar] = useState(<></>);
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);

    //ESTADOS DE DESCARGA
    const[indicadorDescargaPdf, setIndicadorDescargaPdf] = useState(false);
    const[indicadorDescargaXml, setIndicadorDescargaXml] = useState(false);
    const[indicadorDescargaCdr, setIndicadorDescargaCdr] = useState(false);
    const[indicadorEnvioGRE, setIndicadorEnvioGRE] = useState(false);
    const[indicadorConsultaTicket, setIndicadorConsultaTicket] = useState(false);

    // ==================================================================================================
    //#region HOOKS EFFECT
    // ==================================================================================================

    useEffect(()=>{
        ValidarSesion();
        ObtenerTiposGuia();
        ObtenerListaGuias(filtroSerie, filtroCorrelativo, filtroProveedor, filtroCliente, filtroFechaInicio,
            filtroFechaFin, filtroTipoGuia, 1);
    },[]);

    //#endregion    

    // ==================================================================================================
    //#region HANDLERS
    // ==================================================================================================

    // ESTADOS DE FILTRO
    const HandlerFiltroSerie = (valor) => setFiltroSerie(valor.toUpperCase());
    const HandlerFiltroCorrelativo = (valor) => {
        if(valor == ""){
            setFiltroCorrelativo("");
        }else{
            setFiltroCorrelativo(Number.parseInt(valor));
        }
    }
    const HandlerFiltroProveedor = (valor) => setFiltroProveedor(valor);
    const HandlerFiltroCliente = (valor) => setFiltroCliente(valor);
    const HandlerFiltroFechaInicio = (valor) => setFiltroFechaInicio(valor);
    const HandlerFiltroFechaFin = (valor) => setFiltroFechaFin(valor);
    const HandlerFiltroTipoGuia = (valor) => setFiltroTipoGuia(valor);

    //ESTADOS DE SELECT
    const HandlerSelectTipoGuia = (lista) => {
        setSelectTipoGuia(<>{lista.map((item, index)=>(
            <option key={index} value={item.codigo} >{NMTipoGuiaRemision(item.codigo)}</option>
        ))}</>)
    }

    // ESTADOS DE CONTENIDO
    const HandlerListaGuias = (lista) => setListaGuias(lista);
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);

    //ESTADOS DE DESCARGA
    const HandlerIndicadorDescargaPdf = (valor) => setIndicadorDescargaPdf(valor);
    const HandlerIndicadorDescargaXml = (valor) => setIndicadorDescargaXml(valor);
    const HandlerIndicadorDescargaCdr = (valor) => setIndicadorDescargaCdr(valor);
    const HandlerIndicadorEnvioGRE = (valor) => setIndicadorEnvioGRE(valor);
    const HandlerIndicadorConsultaTicket = (valor) => setIndicadorConsultaTicket(valor);

    // ==================================================================================================
    //#region FUNCIONES
    // ==================================================================================================

    //FUNCIONES ASÍNCRONAS
    async function ObtenerTiposGuia(){
        try {
            let response = await axios.get(URL_TIPOS_GUIA, {
                headers: HEADERS_API
            }).catch(error => {
                if(error.response){
                    throw new Error(error.response.data.title);
                }else{
                    throw new Error(error.message);
                }
            });

            if(response.mensajeError != null){
                throw new Error(response.mensajeError);
            }

            HandlerSelectTipoGuia(response.data.tipos);
        } catch (error) {
            console.log(error.message);
        }
    }
    async function ObtenerListaGuias(serie, correlativo, proveedor, cliente, fInicio, fFin, tipoGuia, pagina){
        try{
            let response = await axios.get(URL_LISTAR_GUIAS,{
                headers: HEADERS_API,
                params:{
                    tipoGuia: tipoGuia,
                    serie: serie,
                    correlativo: correlativo,
                    fInicio: fInicio,
                    fFin: fFin,
                    proveedor: proveedor,
                    cliente: cliente,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerListaGuias(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error.message);
        }
    }
    function QuitarFiltros(){
        HandlerFiltroSerie("");
        HandlerFiltroCorrelativo("");
        HandlerFiltroProveedor("");
        HandlerFiltroCliente("");
        HandlerFiltroFechaInicio("");
        HandlerFiltroFechaFin("");
        HandlerFiltroTipoGuia("");
        ObtenerListaGuias();
    }
    async function DescargarPDF(serie, correlativo, tipoDoc, emisor){
        HandlerIndicadorDescargaPdf(true);
        try{
            let response = await axios.get(URL_DESCARGAR_PDF,{
                headers: HEADERS_API,
                params:{
                    serie: serie,
                    correlativo: correlativo
                },
                responseType: 'blob'
            }).catch(error => {
                throw new Error(error.message);
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Establecer el nombre del archivo para la descarga
            link.setAttribute('download', `${emisor}-${tipoDoc}-${serie}-${correlativo.toString().padStart(8,"0")}.pdf`);

            // Añadir el enlace al documento y disparar el evento de clic
            document.body.appendChild(link);
            link.click();

            // Limpiar recursos
            link.remove();
            window.URL.revokeObjectURL(url);

            HandlerIndicadorDescargaPdf(false);
        }catch(error){
            console.log(error);
            HandlerIndicadorDescargaPdf(false);
        }
    }
    async function DescargarXML(serie, correlativo, tipoDoc, emisor){
        try{
            HandlerIndicadorDescargaXml(true);
            let response = await axios.get(URL_DESCARGAR_XML,{
                headers: HEADERS_API,
                params:{
                    serie: serie,
                    correlativo: correlativo,
                    tipoDoc: tipoDoc,
                    emisor: emisor
                },
                responseType: 'blob'
            }).catch(error => {
                throw new Error(error.message);
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Establecer el nombre del archivo para la descarga
            link.setAttribute('download', `${emisor}-${tipoDoc}-${serie}-${correlativo.toString().padStart(8,"0")}.zip`);

            // Añadir el enlace al documento y disparar el evento de clic
            document.body.appendChild(link);
            link.click();

            // Limpiar recursos
            link.remove();
            window.URL.revokeObjectURL(url);

            HandlerIndicadorDescargaXml(false);
        }catch(error){
            console.log(error);
            HandlerIndicadorDescargaXml(false);
        }
    }
    async function DescargarCDR(serie, correlativo, tipoDoc, emisor){
        try{
            HandlerIndicadorDescargaCdr(true);
            let response = await axios.get(URL_DESCARGAR_CDR,{
                headers: HEADERS_API,
                params:{
                    serie: serie,
                    correlativo: correlativo,
                    tipoDoc: tipoDoc,
                    emisor: emisor
                },
                responseType: 'blob'
            }).catch(error => {
                throw new Error(error.message);
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Establecer el nombre del archivo para la descarga
            link.setAttribute('download', `R-${emisor}-${tipoDoc}-${serie}-${correlativo.toString().padStart(8,"0")}.zip`);

            // Añadir el enlace al documento y disparar el evento de clic
            document.body.appendChild(link);
            link.click();

            // Limpiar recursos
            link.remove();
            window.URL.revokeObjectURL(url);

            HandlerIndicadorDescargaCdr(false);
        }catch(error){
            console.log(error);
            HandlerIndicadorDescargaCdr(false);
        }
    }
    const EnviarGuia = async (datosGuia) =>{
        HandlerIndicadorEnvioGRE(true);
        try{
            let response = await axios.post(URL_ENVIAR_GUIA, datosGuia, {
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });

            QuitarFiltros();
        }catch(error){
            console.log(error.message);
        }finally{
            HandlerIndicadorEnvioGRE(false);
        }
    }
    const ConsultarTicket = async (datosGuia) =>{
        HandlerIndicadorConsultaTicket(true);
        try{
            let response = await axios.post(URL_CONSULTAR_TICKET, datosGuia, {
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });

            QuitarFiltros();
        }catch(error){
            console.log(error.message);
        }finally{
            HandlerIndicadorConsultaTicket(false);
        }
    }

    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaGuias(filtroSerie, filtroCorrelativo, filtroProveedor, filtroCliente, filtroFechaInicio, 
            filtroFechaFin, filtroTipoGuia, pagina);
    }

    // FUNCIÓN ACCIÓN ENVÍO
    const ObtenerAccionEnvio = (cpe) =>{
        switch (cpe.estado) {
            case 'PENDIENTE':
                return (
                <button onClick={e=>EnviarGuia(cpe)} disabled={indicadorEnvioGRE} title="Enviar GRE" className="btn btn-primary mx-1 mx-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-send-fill" viewBox="0 0 16 16">
                        <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"/>
                    </svg>
                </button>);
                break;
            case 'ENVIADO':
                if(cpe.ticket != ""){
                    return (
                    <button onClick={e=>ConsultarTicket(cpe)} disabled={indicadorConsultaTicket} title="Consultar GRE" className="btn btn-primary mx-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-ticket-detailed-fill" viewBox="0 0 16 16">
                            <path d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6zm4 1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5m0 5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5M4 8a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1"/>
                        </svg>
                    </button>
                    );
                }else{
                    return (<></>);
                }
                break;
            case 'OBSERVADO':
                return (
                <button onClick={e=>CargarDetalleObservacion(cpe)} title="Detalles GRE" className="btn btn-primary mx-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64"/>
                    </svg>
                </button>
                );
        
        }
    }

    //FUNCIONES MODAL CONFIRMACION
    const CancelarFormularioAgregar = () =>{
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<></>);
        formulario.classList.add("d-none");
    }

    const CargarDetalleObservacion = (cpe) =>{
        const tituloObservacion = (<>
        <div className="text-center">OBSERVACIÓN</div>
        <div className="text-center">GRE N° {cpe.serie}-{cpe.correlativo.toString().padStart(7, "0")}</div>
        </>);
        const mensajeObservacion = (<>
            <table className="table table-borderless">
                <tbody>
                    <tr>
                        <td className="fw-bold text-end">Tipo GRE:</td>
                        <td>{NMTipoGuiaRemision(cpe.tipoGuia)}</td>
                    </tr>
                    <tr>
                        <td className="fw-bold text-end">Código:</td>
                        <td>{cpe.codigoError}</td>
                    </tr>
                    <tr>
                        <td className="fw-bold text-end">Descripción:</td>
                        <td>{cpe.descripcionError}</td>
                    </tr>
                </tbody>
            </table>
        </>);
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<Confirmacion funcionConfirmar={CancelarFormularioAgregar}
            funcionCancelar={CancelarFormularioAgregar} titulo={tituloObservacion} mensaje={mensajeObservacion} informativo={true} />);
        formulario.classList.remove('d-none');
    }

    //FUNCIÓN MOSTRAR ESTADO
    const EstadoMostrar = (estado, ticket) =>{
        if(estado == "ENVIADO" && ticket == ""){
            return "GENERADO";
        }else{
            return estado;
        }
    }
    //#endregion

    //#region CONTENIDO
    return (
        <>
        <Menu/>
        <div id='formulario-agregar' className='d-none'>
            {modalAgregar}
        </div>
        <div className="container">
            <div className="row">
                <div className="col-12 py-2 border-bottom border-secondary text-secondary">
                    <h2>{dB64(localStorage.getItem('r6'))}</h2>
                </div>
                <div className="col-12 py-3 text-center">
                    <h2>GUÍAS DE REMISIÓN</h2>
                </div>
                <div className="d-flex">
                    <div className="p-2 ">
                        <Link to="/nueva-guia">
                            <button className="btn btn-primary">Nueva GRE REMITENTE</button>
                        </Link>
                    </div>
                    <div className="p-2 ">
                        <Link to="/nueva-guia-transportista">
                            <button className="btn btn-primary">Nueva GRE TRANSPORTISTA</button>
                        </Link>
                    </div>
                </div>
                {/* FILTROS */}
                <div className="col-12 col-md-2 p-1">
                    <div className="form-floating">
                        <select onChange={(e)=>HandlerFiltroTipoGuia(e.target.value)} value={filtroTipoGuia} className="form-select" id="filtro-tipo-guia">
                            <option value="">Seleccionar</option>
                            {selectTipoGuia}
                        </select>
                        <label htmlFor="filtro-tipo-guia">Tipo GRE</label>
                    </div>
                </div>
                <div className="col-6 col-md-2 p-1">
                    <div className="form-floating">
                        <input onChange={e=>HandlerFiltroSerie(e.target.value)} value={filtroSerie} maxLength={4} type="text" className="form-control" placeholder="Serie" id="filtro-serie" autoComplete="off"/>
                        <label htmlFor="filtro-serie">Serie</label>
                    </div>
                </div>
                <div className="col-6 col-md-2 p-1">
                    <div className="form-floating">
                        <input onChange={e=>HandlerFiltroCorrelativo(e.target.value)} value={filtroCorrelativo} type="number" className="form-control" placeholder="Correlativo" id="filtro-correlativo" autoComplete="off"/>
                        <label htmlFor="filtro-correlativo">Correlativo</label>
                    </div>
                </div>
                <div className="col-12 col-md-3 p-1">
                    <div className="form-floating">
                        <input onChange={e=>HandlerFiltroFechaInicio(e.target.value)} value={filtroFechaInicio} id="filtro-fecha-inicio" type="date" className="form-control" placeholder="Desde" autoComplete="off"/>
                        <label htmlFor="filtro-fecha-inicio">Desde</label>
                    </div>
                </div>
                <div className="col-12 col-md-3 p-1">
                    <div className="form-floating">
                        <input onChange={e=>HandlerFiltroFechaFin(e.target.value)} value={filtroFechaFin} id="filtro-fecha-fin" type="date" className="form-control" placeholder="Hasta" autoComplete="off"/>
                        <label htmlFor="filtro-fecha-fin">Hasta</label>
                    </div>
                </div>
                <div className="col-12 col-md-5 p-1">
                    <div className="form-floating">
                        <input onChange={e=>HandlerFiltroProveedor(e.target.value)} value={filtroProveedor} id="filtro-proveedor" type="text" className="form-control" placeholder="Proveedor" autoComplete="off"/>
                        <label htmlFor="filtro-proveedor">Proveedor</label>
                    </div>
                </div>
                <div className="col-12 col-md-5 p-1">
                    <div className="form-floating">
                        <input onChange={e=>HandlerFiltroCliente(e.target.value)} value={filtroCliente} id="filtro-cliente" type="text" className="form-control" placeholder="Destinatario" autoComplete="off"/>
                        <label htmlFor="filtro-cliente">Destinatario</label>
                    </div>
                </div>
                <div className="col-12 col-md-2 p-1">
                    <button onClick={e=>ObtenerListaGuias(filtroSerie, filtroCorrelativo, filtroProveedor, filtroCliente, filtroFechaInicio,
            filtroFechaFin, filtroTipoGuia)} className="btn btn-primary w-100 my-1">Filtrar</button>
                    <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
                </div>
                {/* TABLA */}
                <div className="contenedor-tabla py-4">
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>N° Guía</th>
                                <th>Motivo de Traslado</th>
                                <th>Fecha de Emisión</th>
                                <th>Proveedor</th>
                                <th>Destinatario</th>
                                <th>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listaGuias.length > 0 ? listaGuias.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.serie}-{item.correlativo.toString().padStart(7,"0")}</td>
                                        <td>{item.tipoGuia == "09" && NMMotivoTrasladoLista(item.motivoTraslado)}</td>
                                        <td>{MostrarFecha(item.fechaEmision)}</td>
                                        <td>{item.proveedor}</td>
                                        <td>{item.cliente}</td>
                                        <td>{EstadoMostrar(item.estado, item.ticket)}</td>
                                        <td>
                                            <div className="d-flex">
                                                {
                                                item.indicadorXML == 1 && (
                                                    <button onClick={e=>DescargarXML(item.serie, item.correlativo, item.tipoGuia, item.emisor)} disabled={indicadorDescargaXml} className="btn btn-warning">
                                                        {indicadorDescargaXml ? "..." : "XML"}
                                                    </button> 
                                                )
                                                }
                                                <button onClick={e=>DescargarPDF(item.serie, item.correlativo, item.tipoGuia, item.emisor)} disabled={indicadorDescargaPdf} className="btn btn-danger mx-1">
                                                    {indicadorDescargaPdf ? "..." : "PDF"}
                                                </button>
                                                {
                                                item.indicadorCDR == 1 && (
                                                    <button onClick={e=>DescargarCDR(item.serie, item.correlativo, item.tipoGuia, item.emisor)} disabled={indicadorDescargaCdr} className="btn btn-success">
                                                        {indicadorDescargaPdf ? "..." : "CDR"}
                                                    </button>)
                                                }
                                                {
                                                ObtenerAccionEnvio(item)
                                                } 
                                            </div>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={7} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-center">
                    {paginador}
                </div>
            </div>
        </div> 
        </>
    );
    //#endregion
}

// ==================================================================================================
//#region CONSTANTES
// ==================================================================================================

const URL_TIPOS_GUIA = process.env.REACT_APP_URL_TIPOS_GUIA;
const URL_LISTAR_GUIAS = process.env.REACT_APP_URL_LISTAR_GUIAS;
const URL_DESCARGAR_PDF = process.env.REACT_APP_URL_DESCARGAR_PDF;
const URL_DESCARGAR_XML = process.env.REACT_APP_URL_DESCARGAR_XML;
const URL_DESCARGAR_CDR = process.env.REACT_APP_URL_DESCARGAR_CDR;
const URL_ENVIAR_GUIA = process.env.REACT_APP_URL_ENVIAR_GUIA;
const URL_CONSULTAR_TICKET = process.env.REACT_APP_URL_CONSULTAR_TICKET;

//#endregion